import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { justVoted: { type: Boolean, default: false } }

  // Turbo morph can update data attributes on the existing node without
  // reconnecting Stimulus, so connect() never saw the first upvote. A value
  // callback fires on connect AND on later attribute changes.
  justVotedValueChanged(value) {
    if (!value) return
    // Cached snapshots restore the post-vote DOM; skip the preview pass and
    // clear the flag so a later restore cannot fire the celebration again.
    if (document.documentElement.hasAttribute("data-turbo-preview")) {
      this.justVotedValue = false
      return
    }
    this.element.classList.add("is-bounce")
    this.celebrate()
    this.confetti()
    this.justVotedValue = false
  }

  celebrate() {
    const template = document.getElementById("mascot-celebrate-template")
    if (!template) return
    const wrap = document.createElement("div")
    wrap.className = "mascot-celebrate-burst"
    wrap.setAttribute("aria-hidden", "true")
    wrap.append(template.content.cloneNode(true))
    document.body.append(wrap)
    window.setTimeout(() => wrap.remove(), 2300)
  }

  confetti() {
    const canvas = document.createElement("canvas")
    canvas.className = "vote-confetti"
    canvas.setAttribute("aria-hidden", "true")
    canvas.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:80"
    canvas.width = window.innerWidth
    canvas.height = window.innerHeight
    document.body.appendChild(canvas)
    const ctx = canvas.getContext("2d")
    const colors = ["#c45c26", "#e8b56a", "#2a2118", "#8fcb6a", "#f4efe4"]
    const origin = this.element.getBoundingClientRect()
    const bits = Array.from({ length: 70 }, () => ({
      x: origin.left + origin.width / 2,
      y: origin.top + origin.height / 2,
      vx: (Math.random() - 0.5) * 11,
      vy: Math.random() * -9 - 3,
      w: 5 + Math.random() * 5,
      h: 3 + Math.random() * 4,
      color: colors[Math.floor(Math.random() * colors.length)],
      rot: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.4
    }))
    let frame = 0
    const tick = () => {
      frame += 1
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      bits.forEach((bit) => {
        bit.vy += 0.22
        bit.x += bit.vx
        bit.y += bit.vy
        bit.rot += bit.vr
        ctx.save()
        ctx.translate(bit.x, bit.y)
        ctx.rotate(bit.rot)
        ctx.fillStyle = bit.color
        ctx.fillRect(-bit.w / 2, -bit.h / 2, bit.w, bit.h)
        ctx.restore()
      })
      if (frame < 90) requestAnimationFrame(tick)
      else canvas.remove()
    }
    tick()
  }
}
